export class Leave {
    public day: Array<string>;
    public leaveType: string;
    public flag: boolean;
    public disableTimeSheetEntry: boolean;
    public value: number;
    public active: boolean;
    public type: string;
    constructor(data: any = {}) {
        this.day = data || '';
        this.leaveType = '';
        this.type = '';
        this.flag = false;
        this.disableTimeSheetEntry = false;
        this.value = 0;
        this.active = true;
    }
}

export class DateDisplay {
    public day: string;
    public date: number;
    public flag: boolean;
    public disableTimeSheetEntry: boolean;
    public total: number;
    constructor(data: any = {}) {
        this.day = data.day || '';
        this.date = data.date || null;
        this.flag = data.flag || true;
        this.disableTimeSheetEntry = data.disableTimeSheetEntry || false;
        this.total = data.total || 0;
    }
}




// WEBPACK FOOTER //
// ./src/app/employee/timesheet-entry/timesheet.interface.ts